module.exports = "/assets/data/c3d2878bc29ec384b411f7bbed069b9d-NG21.data.json";